/*
name : leaselink plugin
autor: ematique
desc: glownym zadaniem plagiunu jest integracja serwisu prtnera z serwisem leaselink
*/
(function ($) {


    // ustawienia globale plugina
    var _settings = {
        RegisterUrl: "https://online.leaselink.pl/api/RegisterPartnerSite",
        OfferUrl: "https://online.leaselink.pl/api/OfferForClient",
        OfferGetUrl: "https://online.leaselink.pl/process/choose.offer",
        GetStatusUrl: "https://online.leaselink.pl/api/ClientTransactionStatus",
        DeliveryConfirmationUrl: "https://online.leaselink.pl/api/ClientTransactionDeliveryConfirmation",
        //RegisterUrl: "/api/RegisterPartnerSite",
        //OfferUrl: "/api/OfferForClient",
        //OfferGetUrl: "/process/choose.offer/",
        ApiKey: "",
        PartnerName: ""
    };

    // przykaldowe zpytanie - pelen
    var _sampleRequest = {
        "ClientGoBackUrl": "http://onet.pl",
        "SaveDataEmail": "test@onet.pl",
        "SaveDataPhone": "123123123",
        "TypeOfDelivery": "1",
        "CustomerExternalDocument": "1234",
        "Requestors": [{
            "IdentificationNumber1": "0000000000",
            "RequestorName": "eddddd"
        }],
        "RequestItems": [{
            "TaxCode": "23",
            "Tax": "23",
            "Quantity": 1,
            "Name": "test",
            "CategoryLevel1": "P.Cat.10",
            "NetPrice": 1,
            "NetValue": 1,
            "GrossPrice": 1.23,
            "GrossValue": 1.23,
            "TaxValue": 0.23
        }],
        "FullRecalculation": true,
        "PartnerUserGuid": "b81dfca1d6454f5294d8ee7853cd1e47",
        "PartnerUserName": "XXXXXX, YYYYYYYY",
        "PartnerName": "XXXXXXX",
        "SaveInProcess": false,
        "Simulation": true
    };

    // domyslnae zapytanie
    var _request = {
        "ClientGoBackUrl": "",
        "PartnerName": "",
        "RequestItems": [],
        "FullRecalculation": true,
        "SaveInProcess": false,
        "Simulation": true
    };

    // domyslny produkt
    var _product = {
        "TaxCode": "23",
        "Tax": "23",
        "Quantity": 1,
        "Name": "test",
        "CategoryLevel1": "P.Cat.10",
        "NetPrice": 1,
        "NetValue": 1,
        "GrossPrice": 1.23,
        "GrossValue": 1.23,
        "TaxValue": 0.23
    };


    // inicjalizacja polaczenia
    $.llInit = function (options, callbackOk, callbackError) {

        // rozszerzenie infomracji
        _settings = $.extend(_settings, options);

        // zapytanie
        var __request = {
            "ApiKey": _settings.ApiKey
        };

        // wyslanie zapytania
        $.ajax({
            url: _settings.RegisterUrl,
            data: JSON.stringify(__request),
            type: "POST",
            contentType: 'application/json; charset=utf-8',
            dataType: "json",
            success: function (d) {

                if (d.StatusCode === 200) {
                    // wykonanie w przypadku poprawngo przetowrzenia
                    _settings.Token = d.Result.Token;
                    _settings.ValidTo = d.Result.ValidTo;
                    _settings.PartnerName = d.Result.PartnerName || undefined;
                    _settings.PartnerUserGuid = d.Result.PartnerUserGuid || undefined;
                    _settings.PartnerUserName = d.Result.PartnerUserName || undefined;

                    //
                    if (typeof callbackOk === "function") callbackOk(d);
                    else console.debug("llInit: OK");
                } else {

                    // wykonanie w przypadku niepoprawngo przetowrzenia
                    // StatusCode !== 200
                    _settings.Token = undefined;
                    _settings.ValidTo = undefined;
                    _settings.PartnerName = undefined;
                    _settings.PartnerUserGuid = undefined;
                    _settings.PartnerUserName = undefined;

                    //
                    if (typeof callbackError === "function") callbackError(d);
                    else console.debug("llInit: ERROR");

                }
            },
            error: function (e) {
                // wykonanie w przypadku niepoprawngo przetowrzenia
                _settings.Token = undefined;
                _settings.ValidTo = undefined;
                _settings.PartnerName = undefined;
                _settings.PartnerUserGuid = undefined;
                _settings.PartnerUserName = undefined;

                //
                if (typeof callbackError === "function") callbackError(e);
                else console.debug("llInit: ERROR");
            }
        });

        return this;
    };

    // pobranie tokena
    $.llGetToken = function () {
        return _settings.Token || undefined;
    };

    // pobranie nazwy partnera
    $.llGetPartnerName = function () {
        return _settings.PartnerName || undefined;
    };

    $.llGetOfferData = function (fullOffer) {
        var _offer = {
            AggragatedCalulationId: fullOffer.AggragatedCalulationId
        };

        return _offer;
    };

    // dane do zapytania
    $.llGetSampleRequestData = function () {
        return _sampleRequest;
    };

    // pobranie oferty
    // product -> dane produktowe
    // callbackOk -> wywolanie funkcji w przypadku poprawnego przetworzenia zapytania
    // callbackError -> wywolanie funkcji w przypadku bledu zapytania
    $.llGetOffer = function (request, callbackOk, callbackError, isSample) {

        // rozszerzenie zapytania
        var __request = $.extend(_request, request);
        __request = (isSample ? _sampleRequest : _request)


        // umiesczenie w zapytaniu
        __request.PartnerName = _settings.PartnerName;
        __request.PartnerUserGuid = _settings.PartnerUserGuid;
        __request.PartnerUserName = _settings.PartnerUserName;

        // wyslanie zapytania
        $.ajax({
            url: _settings.OfferUrl,
            type: "POST",
            contentType: 'application/json; charset=utf-8',
            dataType: "json",
            beforeSend: function (xhr) { xhr.setRequestHeader('x-auth-leaselink', $.llGetToken()); },
            data: JSON.stringify(__request),
            success: function (d) {

                if (d.StatusCode === 200) {
                    // wykonanie w przypadku poprawngo przetowrzenia
                    if (typeof callbackOk === "function") callbackOk(d.Result);
                    else console.debug("llGetOffer: OK");
                } else {
                    // wykonanie w przypadku niepoprawngo przetowrzenia
                    if (typeof callbackError === "function") callbackError(d.Error);
                    else console.debug("llGetOffer: ERROR");
                }
            },
            error: function (e) {
                // wykonanie w przypadku niepoprawngo przetowrzenia
                if (typeof callbackError === "function") callbackError(e);
                else console.debug("llGetOffer: ERROR");
            }
        });

        return this;
    }


    // przeslanie finalnego zamowienia do reakalkulacji oraz przekierowanie do procesu LL
    $.llCompleteOffer = function (request, callbackOk, callbackError, callbackBeforeRedirect) {

        // wykonanie zadania przed przekierowaniem
        if (typeof callbackBeforeRedirect === "function") if (callbackBeforeRedirect() === false) return;

        // przygotowanie oferty
        request.SaveInProcess = true;
        request.Simulation = false;

        $.llGetOffer(request, function (d) {

            // wykonanie w przypadku poprawngo przetowrzenia
            var AggragatedCalulationId = d.AggragatedCalulationId;
            var url = _settings.OfferGetUrl + "/" + AggragatedCalulationId;

            // w przypadku poprawnego przekazania
            if (typeof callbackOk === "function") callbackOk(url, d);
            else console.debug("llCompleteOffer: OK " + url);

        }, function (e) {
            // wykonanie w przypadku niepoprawngo przetowrzenia
            if (typeof callbackError === "function") callbackError(e);
            else console.debug("llCompleteOffer: ERROR");
        });

        // przekeirowanie

        return this;
    }

    // pobranie status transakcji
    $.llGetStatus = function (transactionId, options, callbackOk, callbackError) {

        // opcje
        var _options = options || {};
        var _attachments = _options.attachments || false;

        // zbudowanie url
        var _url = _settings.GetStatusUrl + "/" + transactionId;
        _url += "?attachments=" + _attachments;

        // wywolanie
        $.ajax({
            url: _url,
            type: "GET",
            contentType: 'application/json; charset=utf-8',
            dataType: "json",
            beforeSend: function (xhr) { xhr.setRequestHeader('x-auth-leaselink', $.llGetToken()); },
            success: function (d) {
                // wykonanie w przypadku poprawne pobrania
                if (typeof callbackOk === "function") callbackOk(d);
                else console.debug("llGetStatus: OK " + url);

            },
            error: function (e) {
                // wykonanie w przypadku niepoprawngo przetowrzenia
                if (typeof callbackError === "function") callbackError(e);
                else console.debug("llGetStatus: ERROR");
            }
        });

        return this;
    };

    // przykladowawy komunikat dla statsu dostawy
    $.llGetDeliveryStatusExample = function () {
        return {
            Status: "ASSET_IN_WAY",
            Data: {
                DeliveryNumber: "1234567890",
                CompanyName: "MOJA PACZKA LTD",
                DateOfSend: "2000-01-01",
                DeliveryLink: "http://gdziemojapaczka.pl?number=1234567890",
                ClientName: "TEST",
                StreetName: "Blotna",
                StreetNumber: "0",
                PostalCode: "00-000",
                City: "Warszawa",
                EmployerFirstName: "JAN",
                EmployerSecondName: "KOWAL",
                AddressOfCollectPoint: "BLOTNA ZACHLAPANA 8"
            },
            ItemData: [
                {
                    Name: "test",
                    ItemID: 11,
                    ItemTypeReferenceNumber: "ABCDF",
                    ItemNumber: "22",
                    SerialNumber: "SN1234",
                    ProducerName: "PRODUCER",
                    Brand: "BRAND",
                    Model: "MODEL",
                    ProductionYear: "2009",
                    PKWIU: "1234",
                    StoreStatus: "InStock"
                }
            ]
        };
    };

    // pobranie status transakcji
    $.llSetDeliveryStatus = function (transactionId, deliveryData, callbackOk, callbackError) {

        // dane
        var _deliveryData = deliveryData || {};

        // zbudowanie url
        var _url = _settings.DeliveryConfirmationUrl + "/" + transactionId;

        // wywolanie
        $.ajax({
            url: _url,
            data: JSON.stringify(_deliveryData),
            type: "PUT",
            contentType: 'application/json; charset=utf-8',
            dataType: "json",
            beforeSend: function (xhr) { xhr.setRequestHeader('x-auth-leaselink', $.llGetToken()); },
            success: function (d) {
                // wykonanie w przypadku poprawne pobrania
                if (typeof callbackOk === "function") callbackOk(d);
                else console.debug("llSetDeliveryStatus: OK " + url);

            },
            error: function (e) {
                // wykonanie w przypadku niepoprawngo przetowrzenia
                if (typeof callbackError === "function") callbackError(e);
                else console.debug("llSetDeliveryStatus: ERROR");
            }
        });

        return this;
    };

}(jQuery));
